<template>

	<div>
		<template v-if="layout == 'side'">
			<!--------------------
		START - Team Members
		-------------------->
			<div class="element-wrapper">
				<div class="element-actions actions-only">
					<div @click="showCollapse = !showCollapse"
					     :class="showCollapse ? 'collapsed' : null">
				<span v-if="showCollapse > 0">
								<i class="os-icon os-icon-minus-circle"></i>
							</span>
						<span v-if="showCollapse == 0">
								<i class="os-icon os-icon-plus-circle"></i>
							</span>
					</div>
				</div>

				<h6 class="element-header"  @click="showCollapse = !showCollapse"
				    :class="showCollapse ? 'collapsed' : null" >
					{{ title }}
				</h6>
				<div class="element-box-tp">
					<b-collapse v-model="showCollapse" id="aa">
						<div class="alert" v-if="status > 200">
					<span v-if="status == 401">
						{{ t.error.access_denied_content }}
					</span>
							<span v-if="status == 404">
						{{ t.error.notfound_content_list }}
					</span>
						</div>
						<div class="users-list-w" v-if="status == 200">
							<div class="user-w with-status status-green" v-for="user in users">
								<div class="user-avatar-w">
									<div class="user-avatar">
										<img alt="" :src="api+'api/v1/users/get/profile_pic/'+user.id">
									</div>
								</div>
								<div class="user-name">
									<h6 class="user-title">
										{{ user.firstName }} {{ user.lastName }}
									</h6>
									<div class="user-role">
										{{ user.group.name }}
									</div>
								</div>
								<router-link :to="{name: 'conversation_new', params: {uid: user.id} }" class="user-action">
									<div class="os-icon os-icon-email-forward"></div>
								</router-link>
							</div>
						</div>
						<div v-if="pagination">
							<router-link :to="{name: 'User', query: this.filter }" class="centered-load-more-link" href="#" v-if="pagination.pageCount > 1"><span>{{ t.show_all }}</span></router-link>
						</div>
					</b-collapse>
				</div>
			</div>
			<!--------------------
			END - Team Members
			-------------------->
		</template>

		<template v-if="layout == 'vertical'">

			<div class="element-wrapper compact pt-4">
				<div class="element-actions d-none d-sm-block">
					<a class="btn btn-primary btn-sm" href="#"><i class="os-icon os-icon-ui-22"></i><span>Add Account</span></a><a class="btn btn-success btn-sm" href="#"><i class="os-icon os-icon-grid-10"></i><span>Make Payment</span></a>
				</div>
				<h6 class="element-header">
					Send Money To
				</h6>
				<div class="element-box-tp">
					<div class="inline-profile-tiles">
						<div class="row">

							<div class="col-4 col-sm-3 col-xxl-2">
								<div class="profile-tile profile-tile-inlined">
									<a class="profile-tile-box faded" href="users_profile_small.html">
										<div class="pt-new-icon">
											<i class="os-icon os-icon-plus"></i>
										</div>
										<div class="pt-user-name">
											New<br/> Account
										</div>
									</a>
								</div>
							</div>

							<div class="col-4 col-sm-3 col-xxl-2" v-for="user in users">
								<div class="profile-tile profile-tile-inlined">
									<router-link class="profile-tile-box" :to="{query: {_mt_id: user.id}}">
										<div  v-on:click="$refs.transferModal.open()">
											<div class="pt-avatar-w">
												<img alt="" :src="api+'api/v1/users/get/profile_pic/'+user.id">
											</div>
											<div class="pt-user-name">
												{{ user.firstName }}<br/> {{ user.lastName }}
											</div>
										</div>

									</router-link>
								</div>
							</div>

						</div>
					</div>
				</div>
			</div>

			<sweet-modal ref="transferModal" v-on:close="closeTransferModal" :overlay-theme="modalTheme" :modal-theme="modalTheme">
				<moneyTransfer />
			</sweet-modal>
		</template>
	</div>

</template>

<script>
    import moneyTransfer from '@/components/accounting/moneyTransfer'
    export default {
        name: 'userWidget',
        components: { moneyTransfer },
        data () {
            return {
                api: window.api,
                t: this.$root.t,
	            users: [],
	            status: 0,
                showCollapse: false,
	            pagination: null,
                modalTheme: 'light',
            }
        },
	    props: {
            filter: {
                type: Object
            },
		    title: '',
            visible: {
                default: 0
            },
		    collapsed: {
			    default: false
		    },
            layout: {
                default: 'side'
            }
	    },
	    mounted () {
            this.modalTheme = (this.$root.darkMode) ? 'dark' : 'light'
            this.$bus.$on('darkMode', (payload) => {
                this.modalTheme = (payload) ? 'dark' : 'light'
            });

            this.showCollapse = this.collapsed;
            this.fetchUsers();
	    },
	    methods: {
            closeTransferModal () {
                this.userOpened = false;
                this.$router.replace({params: {id: null}, query: this.filter.model});
            },
            fetchUsers () {
                this.$http.get(api+'api/v1/users',
	                { params: this.filter }
                ).then(response => {
                    // get body data
                    //response.body.result.locale
                    this.users = response.body.result.users;
                    this.status = response.status;
                    this.pagination = response.body.result.pagination

                }, response => {
                    // error callback
                    this.status = response.status;
                })
            }
	    }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/user/widget/userWidget.vue